import React from 'react';
import { useHoldingSearchModule } from '../../Modules';
import {
  HoldingSearchItemData,
  HoldingSearchItem,
  createHoldingSearchItem,
  isHoldingSearchItem,
  SearchItem,
} from '@benzinga/search-modules';
import { TokenData } from '../tokenize';
import { ExpressionModule, ExpressionSearchModule } from './ExpressionModules';

export interface HoldingExpressionData {
  leftOperand: 'Tickers.name';
  operator: 'object';
  rightOperand: { holding_name: string };
}

export interface HoldingExpressionModule extends ExpressionModule<HoldingSearchItemData> {
  toTokenData: (item: SearchItem) => HoldingExpressionData | undefined;
  fromTokenData: (token: TokenData<unknown>) => HoldingSearchItem | undefined;
}

export const isHoldingExpressionData = (token: TokenData<unknown>): token is HoldingExpressionData => {
  return (
    token.leftOperand === 'Tickers.name' &&
    token.operator === 'object' &&
    typeof token.rightOperand === 'object' &&
    token.rightOperand != null &&
    'holding_name' in token.rightOperand
  );
};

export const createHoldingExpressionModule = (): HoldingExpressionModule => {
  return {
    fromTokenData: token => {
      if (!isHoldingExpressionData(token)) return undefined;
      return createHoldingSearchItem(token.rightOperand.holding_name);
    },
    toTokenData: item => {
      if (!isHoldingSearchItem(item)) return undefined;
      return {
        leftOperand: 'Tickers.name',
        operator: 'object',
        rightOperand: { holding_name: item.data.holdingName },
      };
    },
  };
};

export const useHoldingExpressionSearchModule = (): ExpressionSearchModule => {
  const holdingModule = useHoldingSearchModule();
  return React.useMemo(() => ({ ...holdingModule, expression: createHoldingExpressionModule() }), [holdingModule]);
};
